exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4{font-size:22px}h4 span{font-weight:600}p{color:#878787}p span{color:#333333;font-weight:600}.app-modal-body,.app-modal-header{padding:0px 15px}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/things/shared/clone-popup.component.scss
// module id = 1390
// module chunks = 0